import { UserSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  manager_id: {
    'ui:widget': UserSelectionWidget,
  },
});

export default uiSchema;
